import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=23781d2e&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&lang=js&"
export * from "./PostDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=23781d2e&prod&lang=less&scoped=true&"
import style1 from "./PostDetail.vue?vue&type=style&index=1&id=23781d2e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23781d2e",
  null
  
)

export default component.exports